<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue